import {getStationIdFromLocalStorage} from '../../../services/parametre-document/parametre-document-state.service';

/** Identifiants session pour les appels `/api/parametrage/...`. */
export function getParametrageSessionIds(): { stationId: number; userId: number } {
  try {
    const raw = localStorage.getItem('currentUser');
    if (raw == null || raw === '') {
      return { stationId: 0, userId: 0 };
    }
    const currentUser = JSON.parse(raw) as Record<string, unknown>;
    const userRaw = currentUser['id'] ?? currentUser['user_id'];
    const userId = Number(userRaw);
    const stationId = getConnectedStationIdFromUser(currentUser);
    return {
      stationId: Number.isFinite(stationId) ? Math.floor(stationId) : 0,
      userId: Number.isFinite(userId) ? Math.floor(userId) : 0
    };
  } catch {
    return { stationId: 0, userId: 0 };
  }
}

function getConnectedStationIdFromUser(currentUser: Record<string, unknown>): number {
  const stations = currentUser['stations'];
  if (Array.isArray(stations) && stations.length > 0) {
    const list = stations as Record<string, unknown>[];
    const connected = list.find((s) => s['isConnecte'] === 1);
    const st = connected ?? list[0];
    const sid = st?.['station_id'] ?? st?.['id'];
    const n = Number(sid);
    if (Number.isFinite(n) && n > 0) {
      return Math.floor(n);
    }
  }
  return getStationIdFromLocalStorage();
}
